$('.media-carousel').each(function () {
  const $this = $(this)
  const $container = $this.closest('.carousel-container')

  const disableAutoplay =
    $this.data('disable-autoplay') === true || $this.attr('data-disable-autoplay') === 'true'

  console.log(disableAutoplay)

  const swiperOptions = {
    navigation: {
      nextEl: $container.find('.carousel-next')[0],
      prevEl: $container.find('.carousel-previous')[0],
    },
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    pagination: {
      el: $container.find('.swiper-pagination')[0], // scoped to this carousel
      clickable: true,
      renderBullet: function (index, className) {
        return `
          <span class="${className} circle-wrap">
            <svg viewBox="0 0 36 36" class="circular-chart absolute top-0 left-0">
              <path class="circle"
                    stroke-dasharray="60, 100"
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            </svg>
            ${index + 1}
          </span>`
      },
    },

    on: {
      slideChangeTransitionStart: function () {
        $container.find('.swiper-pagination').removeClass('first-run')

        const bullets = $container.find('.swiper-pagination-bullet').toArray()
        bullets.forEach((bullet) => {
          bullet.style.setProperty('--progress', '0%')
        })

        const activeBullet = $container.find('.swiper-pagination-bullet-active')[0]
        if (activeBullet) {
          activeBullet.style.animation = 'none'
          void activeBullet.offsetWidth // reflow
          activeBullet.style.animation = ''
        }
      },
    },
  }

  // Only enable autoplay if not disabled via data attribute
  if (!disableAutoplay) {
    swiperOptions.speed = 1000
    swiperOptions.autoplay = {
      delay: 9000,
      disableOnInteraction: false,
    }
  }

  const swiper = new Swiper(this, swiperOptions)
})

// $('.floor-carousel').each(function () {
//   const $this = $(this)
//
//   let initialSlideIndex = $this.find('.swiper-slide[data-initial-slide="1"]').index()
//   if (initialSlideIndex === -1) {
//     initialSlideIndex = 0 // Default to first slide if no data-initial-slide is set
//   }
//
//   let swiper = new Swiper(this, {
//     grabCursor: false,
//     slidesPerView: 1,
//     spaceBetween: 0,
//     effect: 'fade',
//     fadeEffect: {
//       crossFade: true,
//     },
//     loop: false,
//     allowTouchMove: false,
//     initialSlide: initialSlideIndex,
//     navigation: {
//       prevEl: $this.closest('.floor-carousel-container').find('.carousel-previous')[0],
//       nextEl: $this.closest('.floor-carousel-container').find('.carousel-next')[0],
//     },
//     pagination: {
//       el: $this.closest('.floor-carousel-container').find('.floor-bullets')[0],
//       clickable: true,
//       renderBullet: function (index, className) {
//         const title = $this
//           .closest('.floor-carousel-container')
//           .find('.floor-slide')
//           .eq(index)
//           .attr('data-title')
//
//         return (
//           '<div class="floor-bullet h-auto w-full opacity-100 !mx-0 !px-3 !py-2 !rounded-none hover:bg-taupe rounded-0 bg-transparent !text-left ' +
//           className +
//           '">' +
//           title +
//           '</div>'
//         )
//       },
//     },
//     on: {
//       slideChange: function () {
//         // Update the title on slide change
//         const activeIndex = this.activeIndex
//         const title = $this
//           .closest('.floor-carousel-container')
//           .find('.floor-slide')
//           .eq(activeIndex)
//           .attr('data-title')
//
//         // Update the title in the floor toggle button
//         $('.floor-toggle-button .floor-title').html(title + ':')
//
//         $('.position-selector').attr('data-active-selection', activeIndex)
//       },
//     },
//   })
//
//   $this
//     .closest('.floor-carousel-container')
//     .find('.floor-bullet')
//     .on('click', function () {
//       toggleFloorOptions()
//
//       $('.floor-toggle-button .floor-title').html($(this).html())
//     })
//
//   $('.position-selector').attr('data-active-selection', initialSlideIndex)
// })
//
// $('.floor-toggle-button').on('click', function () {
//   toggleFloorOptions()
// })
//
// function toggleFloorOptions() {
//   $('.floor-toggle-options').slideToggle(300)
//   $('.floor-toggle-options-container').toggleClass('!bg-soft-off-white')
//   $('.floor-toggle-button .icon').toggleClass('rotate-45')
// }
//
// $('[data-floor-select]').on('click', function (event) {
//   let $this = $(this)
//   let $parent = $this.parents('.floorplans-container')
//   let toggleClasses = 'font-bold pointer-events-none hover:!text-gra hover:bg-oransje'
//   let floor = $this.attr('data-floor-select')
//   let index = $('[data-floor="' + floor + '"]').index()
//
//   $parent.find('.floorplans-carousel').each(function () {
//     let swiperElement = $(this)[0]
//     let swiper = swiperElement.swiper
//     swiper.slideTo(index)
//   })
//
//   $parent.find('.floorplans-info-carousel').each(function () {
//     let swiperElement = $(this)[0]
//     let swiper = swiperElement.swiper
//     swiper.slideTo(index)
//   })
//
//   $('.position-selector').attr('data-active-selection', index)
//
//   $parent
//     .find('.floor-toggle [data-floor-select]')
//     .not('[data-floor-select="' + floor + '"]')
//     .removeClass(toggleClasses)
//   $parent.find('.floor-toggle [data-floor-select="' + floor + '"]').addClass(toggleClasses)
//
//   $parent.find('.position-selector a').removeClass('active')
//   $parent.find('.position-selector [data-floor-select=' + floor + ']').addClass('active')
//
//   // $parent.find( '.floor-title' ).html( $this.html() );
// })

$('.floorplan-carousel-container').each(function () {
  const $this = $(this)

  const $imageCarousel = $('.image-carousel', $this)
  const $swiperContainer = $imageCarousel.closest('.swiper-container')
  const $galleryThumbs = $('.gallery-thumbs', $this)

  if (!$imageCarousel.length) {
    return
  }

  const swiper = new Swiper($imageCarousel[0], {
    pagination: {
      el: $swiperContainer.find('.swiper-pagination')[0],
    },
    navigation: {
      nextEl: $imageCarousel.parents('.swiper-container').find('.carousel-next')[0],
      prevEl: $imageCarousel.parents('.swiper-container').find('.carousel-previous')[0],
    },
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
  })

  if ($galleryThumbs.length) {
    const thumbs = new Swiper($galleryThumbs[0], {
      slidesPerView: 'auto',
      spaceBetween: 16,
      centeredSlides: true,
      loop: false,
      slideToClickedSlide: true,
    })

    swiper.controller.control = thumbs
    thumbs.controller.control = swiper
  }
})
